module.exports = __webpack_public_path__ + "img/GAME_BLOCKFLIP.8a0dd12f.png";